import {TRANSPORT_TYPES} from '@common/const'

export function getTransportTypeIcon(catCode: ValuesOf<Dbi.HafasTrafficType>): string {
    const type = TRANSPORT_TYPES.find(({hafas: {id}}) => id === catCode)
    return `transport-${type!.hafas.name}`
}
